import { render, staticRenderFns } from "./sidenav.vue?vue&type=template&id=494c6ab3&scoped=true&"
import script from "./sidenav.vue?vue&type=script&lang=js&"
export * from "./sidenav.vue?vue&type=script&lang=js&"
import style0 from "./sidenav.vue?vue&type=style&index=0&id=494c6ab3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c6ab3",
  null
  
)

export default component.exports